import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "viewHead",
  id: "attn-map-view"
}
const _hoisted_2 = { class: "align-top" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Sentence View")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "q-k attention patterns for a single sentence; line opacity denotes attention weight", -1)
const _hoisted_5 = { class: "attn-btns" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("reset")
const _hoisted_7 = { class: "subtitle" }
const _hoisted_8 = { class: "checkbox-contain" }
const _hoisted_9 = { class: "label" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Hide")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("filter out attention to ")
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("first token")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("[cls]")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("[sep]")
const _hoisted_17 = { class: "half" }
const _hoisted_18 = { class: "label" }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Weight by")
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", null, "weight attentions by the norm of each token's value vector", -1)
const _hoisted_21 = /*#__PURE__*/_createTextVNode("value norm")
const _hoisted_22 = ["id"]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { id: "vis" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", null, [
        _hoisted_3,
        _createVNode(_component_a_tooltip, { placement: "bottom" }, {
          title: _withCtx(() => [
            _hoisted_4
          ]),
          default: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, {
              icon: "info",
              class: "info-icon"
            })
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_a_button, {
          id: "attn-reset",
          class: "clear",
          type: "link",
          onClick: $setup.resetAttn
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.attnMsg), 1),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: _normalizeClass({ half: _ctx.model == 'gpt-2' })
      }, [
        _createElementVNode("p", _hoisted_9, [
          _hoisted_10,
          _createVNode(_component_a_tooltip, { placement: "leftTop" }, {
            title: _withCtx(() => [
              _createElementVNode("span", null, [
                _hoisted_11,
                (_ctx.model === 'gpt-2')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_12, "first token"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_13, "special tokens (cls, sep)"))
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "info",
                class: "info-icon"
              })
            ]),
            _: 1
          })
        ]),
        _withDirectives(_createVNode(_component_a_checkbox, {
          checked: _ctx.hideFirst,
          "onUpdate:checked": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.hideFirst) = $event)),
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.hideTokens('first')))
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }, 8, ["checked"]), [
          [_vShow, _ctx.model == 'gpt-2']
        ]),
        _withDirectives(_createVNode(_component_a_checkbox, {
          checked: _ctx.hideFirst,
          "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.hideFirst) = $event)),
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.hideTokens('first')))
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }, 8, ["checked"]), [
          [_vShow, _ctx.model == 'bert']
        ]),
        _withDirectives(_createVNode(_component_a_checkbox, {
          checked: _ctx.hideLast,
          "onUpdate:checked": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.hideLast) = $event)),
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.hideTokens('last')))
        }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        }, 8, ["checked"]), [
          [_vShow, _ctx.model == 'bert']
        ])
      ], 2),
      _withDirectives(_createElementVNode("div", _hoisted_17, [
        _createElementVNode("p", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_a_tooltip, { placement: "leftTop" }, {
            title: _withCtx(() => [
              _hoisted_20
            ]),
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "info",
                class: "info-icon"
              })
            ]),
            _: 1
          })
        ]),
        _createVNode(_component_a_checkbox, {
          checked: _ctx.weightByNorm,
          "onUpdate:checked": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.weightByNorm) = $event))
        }, {
          default: _withCtx(() => [
            _hoisted_21
          ]),
          _: 1
        }, 8, ["checked"])
      ], 512), [
        [_vShow, _ctx.model == 'gpt-2']
      ])
    ]),
    _createVNode(_Transition, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          id: $props.myID,
          class: "bertviz"
        }, _hoisted_24, 8, _hoisted_22)
      ]),
      _: 1
    })
  ]))
}